/* SAGLOU · Utilidades compartidas del bloque integral (PDP, blog, guía de uso, comunidad e interiores).
   - Entrada suave al aparecer ([data-sgd-reveal]); nada se oculta sin JS ni con movimiento reducido.
   - Aviso visual + anuncio accesible (SGD.say).
   - Copiar al portapapeles con alternativa manual (SGD.copy).
   - Añadir a la bolsa con la API del tema (SaglouCart) y alternativa /cart/add.js (SGD.addToCart).
   - Formato de importes con la moneda activa del mercado (SGD.money). */
(function () {
  'use strict';
  var doc = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!reduce.matches) doc.classList.add('sgd-js');

  var SGD = window.SGD || {};

  /* ----- Entrada al aparecer ----- */
  function reveal() {
    var items = Array.prototype.slice.call(document.querySelectorAll('.sgd [data-sgd-reveal]:not(.is-in)'));
    if (!items.length) return;
    if (reduce.matches || !('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    items.forEach(function (el) { io.observe(el); });
    /* Red de seguridad: nada queda invisible si el observador no llega a dispararse (impresión, capturas). */
    window.setTimeout(function () { items.forEach(function (el) { el.classList.add('is-in'); }); }, 2600);
  }
  SGD.reveal = reveal;

  /* ----- Aviso + región viva ----- */
  var toast, live, timer;
  function ensure() {
    if (!live) {
      live = document.createElement('div');
      live.className = 'sgd-sr';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('role', 'status');
      document.body.appendChild(live);
    }
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'sgd sgd-toast';
      toast.setAttribute('aria-hidden', 'true');
      document.body.appendChild(toast);
    }
  }
  SGD.say = function (msg, visible) {
    ensure();
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 30);
    if (visible === false) return;
    toast.textContent = msg;
    toast.classList.add('is-on');
    window.clearTimeout(timer);
    timer = window.setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  };

  /* ----- Copiar ----- */
  SGD.copy = function (text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(function () { return true; }, function () { return legacy(text); });
    }
    return Promise.resolve(legacy(text));
  };
  function legacy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return !!ok;
    } catch (e) { return false; }
  }

  /* ----- Importes ----- */
  /* Mismo formato que Liquid ({{ x | money }}): usa shop.money_format si la página lo expone en
     data-money-format; si no, el formato del idioma con la moneda activa. */
  function group(n, dec, thou, decSep) {
    var parts = (n / 100).toFixed(dec).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return parts.length > 1 ? parts[0] + decSep + parts[1] : parts[0];
  }
  SGD.money = function (cents) {
    var holder = document.querySelector('[data-money-format]');
    var fmt = holder && holder.getAttribute('data-money-format');
    if (fmt && /\{\{\s*\w+\s*\}\}/.test(fmt)) {
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
        switch (key) {
          case 'amount': return group(cents, 2, ',', '.');
          case 'amount_no_decimals': return group(cents, 0, ',', '.');
          case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
          case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
          case 'amount_with_space_separator': return group(cents, 2, ' ', ',');
          case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
          default: return group(cents, 2, '.', ',');
        }
      }).replace(/<[^>]+>/g, '');
    }
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(doc.lang || 'es-ES', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2) + ' ' + cur; }
  };

  /* ----- Bolsa ----- */
  SGD.addToCart = function (variantId, quantity, properties) {
    var q = Math.max(1, parseInt(quantity, 10) || 1);
    if (window.SaglouCart && typeof window.SaglouCart.addVariant === 'function') {
      return Promise.resolve(window.SaglouCart.addVariant(variantId, { quantity: q, properties: properties, openDrawer: true }));
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var item = { id: Number(variantId), quantity: q };
    if (properties) item.properties = properties;
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'error');
        return j;
      });
    });
  };

  window.SGD = SGD;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
  else reveal();
  document.addEventListener('shopify:section:load', reveal);
})();
